module.exports = __webpack_public_path__ + "static/media/mail.625b8c9c.svg";